import Button from './button';
import ButtonGroup from './button-group';
Button.Group = ButtonGroup;
export default Button;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/button/index.js
// module id = 85
// module chunks = 0